import { lazy } from 'react';

const CharityKRSRoute = lazy(
  () => import(/* webpackChunkName: "CharityKRS" */ '../components/steps/krs-step/KRS'),
);

export default CharityKRSRoute;
